import React, { useState, useEffect, useMemo } from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import Menu from "../sections/Menu";
import Footer from "../sections/Footer";
import AnimatedCounter from "../components/AnimatedCounter";
import PageMeta from "../seo/PageMeta";
import { buildArticleStructuredData } from "../seo/structuredData";

function CaseStudyStaldachBud() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetch("/data/content.json")
      .then((res) => res.json())
      .then((data) => setContent(data))
      .catch((error) => console.error("Error loading JSON:", error));
  }, []);

  const articleStructuredData = useMemo(
    () => [
      buildArticleStructuredData({
        path: "/case-study/staldach-bud",
        headline:
          "Jak Staldach-bud sp. z o.o. oszczędza ponad 9 tysięcy złotych miesięcznie dzięki wdrożeniu eGodzin",
        description:
          "Case study wdrożenia eGodziny w firmie Staldach-bud i wynikających oszczędności.",
        authorName: "Zespół eGodziny",
      }),
    ],
    []
  );

  if (!content) return <div></div>;

  return (
    <>
      <PageMeta
        path="/case-study/staldach-bud"
        structuredData={articleStructuredData}
        ogType="article"
      />
      <Menu />

      <Container
        className="py-5"
        style={{ paddingTop: "120px", minHeight: "90vh", maxWidth: "900px" }}
      >
        <Row className="justify-content-center">
          <Col lg={12} className="px-4">
            <div className="text-center mb-5">
              <h1
                className="mb-4 case-study-title"
                style={{ fontWeight: "bold" }}
              >
                Jak Staldach-bud sp. z o.o. oszczędza ponad 9 tysięcy złotych
                miesięcznie dzięki wdrożeniu eGodzin
              </h1>
            </div>

            <div
              style={{
                backgroundColor: "#f8f9fa",
                borderRadius: "20px",
                padding: "50px",
                marginBottom: "50px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
              }}
            >
              {/* Quote first */}
              <Row className="mb-3">
                <Col md={12}>
                  <blockquote
                    style={{ margin: 0, fontSize: "24px", lineHeight: "1.6", textAlign: "center" }}
                  >
                    <p
                      style={{
                        fontStyle: "italic",
                        marginBottom: "30px",
                        color: "#333",
                        fontSize: "26px",
                      }}
                    >
                      "Jako przedsiębiorca wiecznie przytłoczony ilością zadań i
                      obowiązków, nie zdawałem sobie sprawy, że w tak łatwy
                      sposób można poprawić działanie firmy"
                    </p>
                  </blockquote>
                </Col>
              </Row>

              {/* Logo left, info right */}
              <Row className="align-items-center">
                <Col md={4}>
                  <div style={{ textAlign: "left" }}>
                    <Image
                      src={require("../images/staldach-bud-logo.png")}
                      alt="Staldach-Bud Logo"
                      style={{
                        width: "180px",
                        height: "auto",
                      }}
                    />
                  </div>
                </Col>

                <Col md={8}>
                  <div style={{ textAlign: "left", fontSize: "16px", paddingLeft: "20px" }}>
                    <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
                      Mariusz Wolny
                    </div>
                    <div style={{ color: "#666", marginBottom: "3px" }}>
                      Prezes Zarządu
                    </div>
                    <div style={{ color: "#666" }}>STALDACH-BUD sp. z o.o.</div>
                  </div>
                </Col>
              </Row>
            </div>

            <div className="mb-5">
              <h2
                className="mb-4"
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "#1f2937",
                }}
              >
                O firmie
              </h2>
              <div className="row">
                <div className="col-md-6">
                  <ul
                    style={{
                      fontSize: "18px",
                      lineHeight: "1.8",
                      listStyle: "none",
                      padding: 0,
                    }}
                  >
                    <li className="mb-3">
                      <strong>Branża:</strong> budownictwo
                    </li>
                    <li className="mb-3">
                      <strong>Specjalizacja:</strong> konstrukcje żelbetowe i
                      poszycia dachowe
                    </li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <ul
                    style={{
                      fontSize: "18px",
                      lineHeight: "1.8",
                      listStyle: "none",
                      padding: 0,
                    }}
                  >
                    <li className="mb-3">
                      <strong>Zespół:</strong> 70 pracowników terenowych
                    </li>
                    <li className="mb-3">
                      <strong>Skala:</strong> średnio 8 projektów prowadzonych
                      równolegle
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="mb-5">
              <h2
                className="mb-4"
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "#1f2937",
                }}
              >
                Wyzwania przed wdrożeniem
              </h2>
              <p
                className="mb-4"
                style={{ fontSize: "18px", lineHeight: "1.8" }}
              >
                Codzienna ewidencja czasu pracy była w pełni papierowa:
              </p>
              <ul style={{ fontSize: "18px", lineHeight: "1.8" }}>
                <li className="mb-3">
                  Na każdym projekcie zbierano i podpisywano listy obecności.
                </li>
                <li className="mb-3">
                  Każdy pracownik notował godziny samodzielnie, a zestawienia
                  oddawał dopiero na koniec miesiąca.
                </li>
                <li className="mb-3">
                  Brakowało bieżącej kontroli – zdarzało się, że pracownicy
                  jadący tym samym busem mieli na kartach zupełnie różną liczbę
                  godzin.
                </li>
                <li className="mb-3">
                  Weryfikacja była praktycznie niemożliwa, a nieprawidłowości
                  liczne.
                </li>
                <li className="mb-3">
                  Kadry potrzebowały 3 dni na ręczne przepisywanie kart do
                  Excela; część dokumentów ginęła.
                </li>
                <li className="mb-3">
                  Zestawienia musiały być drukowane i podpisywane przez
                  wszystkich pracowników – zawsze brakowało kilku podpisów.
                </li>
                <li className="mb-3">
                  Księgowa dzieliła wynagrodzenia na tzw. piątki księgowe
                  ręcznie, licząc procent pensji przypadający na poszczególne
                  zlecenia – proces czasochłonny i podatny na błędy.
                </li>
              </ul>
            </div>

            <div className="mb-5">
              <h2
                className="mb-4"
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "#1f2937",
                }}
              >
                Decyzja o wdrożeniu
              </h2>
              <p
                className="mb-4"
                style={{ fontSize: "18px", lineHeight: "1.8" }}
              >
                Firma początkowo rozważała dedykowany system pisany na
                zamówienie, ale oferty na poziomie 120–160 tys. zł okazały się
                zaporowe. Wtedy zdecydowała się na subskrypcję{" "}
                <strong>eGodziny</strong>.
              </p>
              <blockquote
                style={{
                  backgroundColor: "#f8f9fa",
                  borderLeft: "4px solid #407EF9",
                  padding: "20px",
                  margin: "20px 0",
                  fontStyle: "italic",
                  fontSize: "18px",
                  lineHeight: "1.6",
                }}
              >
                "Początkowo chcieliśmy, aby ktoś napisał program specjalnie pod
                nas. Wydawało nam się, że działamy na tyle specyficznie, że nie
                uda się znaleźć gotowego narzędzia, które się u nas sprawdzi."
              </blockquote>
            </div>

            <div className="mb-5">
              <h2
                className="mb-4"
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "#1f2937",
                }}
              >
                Rezultaty
              </h2>
              <ul style={{ fontSize: "18px", lineHeight: "1.8" }}>
                <li className="mb-3">
                  Każdy pracownik codziennie uzupełnia godziny w aplikacji –
                  papierowe listy odeszły w zapomnienie.
                </li>
                <li className="mb-3">
                  Liczba nieprawidłowości spadła drastycznie, a kierownik
                  projektów może zweryfikować każdą rozbieżność tego samego
                  dnia.
                </li>
              </ul>

              <blockquote
                style={{
                  backgroundColor: "#f8f9fa",
                  borderLeft: "4px solid #407EF9",
                  padding: "20px",
                  margin: "30px 0",
                  fontStyle: "italic",
                  fontSize: "18px",
                  lineHeight: "1.6",
                }}
              >
                "Po pierwsze, pracownicy mają świadomość, że dane trafiają od
                razu do biura, co na dzień dobry zmniejszyło ilość dziwnych
                rozbieżności. Po drugie, nawet gdy pojawia się sytuacja budząca
                wątpliwości, możemy zareagować od razu, a nie po 3 tygodniach,
                gdy nikt już nie pamięta o co chodziło."
              </blockquote>

              <ul style={{ fontSize: "18px", lineHeight: "1.8" }}>
                <li className="mb-3">
                  Naliczenie wynagrodzeń trwa obecnie{" "}
                  <strong>1 dzień zamiast 3–4 dni</strong>.
                </li>
                <li className="mb-3">
                  Nie ma potrzeby drukowania i zbierania podpisów – pracownicy
                  potwierdzają miesiąc w aplikacji.
                </li>
              </ul>

              <blockquote
                style={{
                  backgroundColor: "#f8f9fa",
                  borderLeft: "4px solid #407EF9",
                  padding: "20px",
                  margin: "30px 0",
                  fontStyle: "italic",
                  fontSize: "18px",
                  lineHeight: "1.6",
                }}
              >
                "Od zawsze każdy pracownik, zanim otrzymał wypłatę, musiał
                przyjechać do biura i podpisać się pod listą godzin. Okazuje
                się, że podpis wcale nie jest prawnie wymagany – wystarczy
                potwierdzenie w aplikacji."
              </blockquote>

              <p
                className="mb-3"
                style={{ fontSize: "18px", lineHeight: "1.8" }}
              >
                System automatycznie wylicza udział procentowy pensji
                przypadający na dany projekt. Dzięki temu zarząd wreszcie ma
                narzędzie do analizy rentowności poszczególnych zleceń –
                niezwykle pomocne przy startach w przetargach.
              </p>
            </div>

            <div className="mb-5">
              <h2
                className="mb-5 text-center"
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "#1f2937",
                }}
              >
                Oszczędności
              </h2>

              <Row className="mb-4 g-4">
                <Col md={6}>
                  <div
                    className="p-4 text-center"
                    style={{
                      background:
                        "linear-gradient(135deg, #f8f9fa 100%, rgba(255, 255, 255, 0.8) 100%)",
                      borderRadius: "20px",
                      height: "100%",
                      boxShadow: "0 20px 40px rgba(102, 126, 234, 0.3)",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "-50%",
                        left: "-50%",
                        width: "200%",
                        height: "200%",
                        background: "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
                      }}
                    ></div>
                    <div style={{ position: "relative", zIndex: 2 }}>
                      <h4 style={{ 
                        fontSize: "1.25rem",
                        fontWeight: "600", 
                        color: "#1f2937", 
                        marginBottom: "20px",
                        textShadow: "0 1px 2px rgba(0, 0, 0, 0.3)",
                      }}>
                        Kadry
                      </h4>
                      <div
                        style={{
                          fontSize: "2rem",
                          color: "#407EF9",
                          marginBottom: "10px",
                          lineHeight: "1.2",
                          fontWeight: "bold",
                        }}
                      >
                        <AnimatedCounter value={2880} suffix=" zł" />
                      </div>
                      <div
                        style={{
                          fontSize: "0.9rem",
                          color: "#1f2937",
                          marginBottom: "10px",
                          lineHeight: "1.4",
                        }}
                      >
                        48 h miesięcznie
                      </div>
                      <p style={{ 
                        fontSize: "0.9rem", 
                        color: "#666", 
                        margin: 0,
                        lineHeight: "1.4",
                      }}>
                        brak ręcznego przepisywania kart
                      </p>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div
                    className="p-4 text-center"
                    style={{
                      background:
                        "linear-gradient(135deg, #f8f9fa 100%, rgba(255, 255, 255, 0.8) 100%)",
                      borderRadius: "20px",
                      height: "100%",
                      boxShadow: "0 20px 40px rgba(102, 126, 234, 0.3)",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "-50%",
                        left: "-50%",
                        width: "200%",
                        height: "200%",
                        background: "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
                      }}
                    ></div>
                    <div style={{ position: "relative", zIndex: 2 }}>
                      <h4 style={{ 
                        fontSize: "1.25rem",
                        fontWeight: "600", 
                        color: "#1f2937", 
                        marginBottom: "20px",
                        textShadow: "0 1px 2px rgba(0, 0, 0, 0.3)",
                      }}>
                        Nieprawidłowości w godzinach
                      </h4>
                      <div
                        style={{
                          fontSize: "2rem",
                          color: "#407EF9",
                          marginBottom: "10px",
                          lineHeight: "1.2",
                          fontWeight: "bold",
                        }}
                      >
                        <AnimatedCounter value={5600} suffix=" zł" />
                      </div>
                      <p style={{ 
                        fontSize: "0.9rem", 
                        color: "#666", 
                        margin: 0,
                        lineHeight: "1.4",
                      }}>
                        średnio 0,5 h na pracownika tygodniowo miesięcznie
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className="mb-4 g-4">
                <Col md={6}>
                  <div
                    className="p-4 text-center"
                    style={{
                      background:
                        "linear-gradient(135deg, #f8f9fa 100%, rgba(255, 255, 255, 0.8) 100%)",
                      borderRadius: "20px",
                      height: "100%",
                      boxShadow: "0 20px 40px rgba(102, 126, 234, 0.3)",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "-50%",
                        left: "-50%",
                        width: "200%",
                        height: "200%",
                        background: "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
                      }}
                    ></div>
                    <div style={{ position: "relative", zIndex: 2 }}>
                      <h4 style={{ 
                        fontSize: "1.25rem",
                        fontWeight: "600", 
                        color: "#1f2937", 
                        marginBottom: "20px",
                        textShadow: "0 1px 2px rgba(0, 0, 0, 0.3)",
                      }}>
                        Ręczne zestawienia pracowników
                      </h4>
                      <div
                        style={{
                          fontSize: "2rem",
                          color: "#407EF9",
                          marginBottom: "10px",
                          lineHeight: "1.2",
                          fontWeight: "bold",
                        }}
                      >
                        <AnimatedCounter value={700} suffix=" zł" />
                      </div>
                      <p style={{ 
                        fontSize: "0.9rem", 
                        color: "#666", 
                        margin: 0,
                        lineHeight: "1.4",
                      }}>
                        15 minut miesięcznie na pracownika
                      </p>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div
                    className="p-4 text-center"
                    style={{
                      background:
                        "linear-gradient(135deg, #f8f9fa 100%, rgba(255, 255, 255, 0.8) 100%)",
                      borderRadius: "20px",
                      height: "100%",
                      boxShadow: "0 20px 40px rgba(102, 126, 234, 0.3)",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "-50%",
                        left: "-50%",
                        width: "200%",
                        height: "200%",
                        background: "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
                      }}
                    ></div>
                    <div style={{ position: "relative", zIndex: 2 }}>
                      <h4 style={{ 
                        fontSize: "1.25rem",
                        fontWeight: "600", 
                        color: "#1f2937", 
                        marginBottom: "20px",
                        textShadow: "0 1px 2px rgba(0, 0, 0, 0.3)",
                      }}>
                        Analiza rentowności projektów
                      </h4>
                      <div
                        style={{
                          fontSize: "1.2rem",
                          color: "#407EF9",
                          fontWeight: "bold",
                          lineHeight: "1.4",
                        }}
                      >
                        bezcenna przewaga przy kalkulacji ofert i przetargach
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              <div className="text-center mt-5">
                <div
                  style={{
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    borderRadius: "20px",
                    padding: "40px",
                    boxShadow: "0 20px 40px rgba(102, 126, 234, 0.3)",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "-50%",
                      left: "-50%",
                      width: "200%",
                      height: "200%",
                      background: "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
                      animation: "pulse 3s ease-in-out infinite",
                    }}
                  ></div>
                  <div style={{ position: "relative", zIndex: 2 }}>
                    <div
                      style={{
                        fontSize: "4rem",
                        fontWeight: "bold",
                        color: "white",
                        marginBottom: "15px",
                        textShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
                      }}
                    >
                      <AnimatedCounter value={9180} suffix=" zł" duration={3000} />
                    </div>
                    <p style={{ 
                      fontSize: "1.3rem", 
                      margin: 0, 
                      fontWeight: "600",
                      color: "white",
                      textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
                    }}>
                      Łączne miesięczne oszczędności
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center">
              <h3 className="mb-4">Chcesz osiągnąć podobne rezultaty?</h3>
              <div className="case-study-cta">
                <Button
                  className="button-default btn-lg"
                  onClick={() =>
                    window.open(
                      "https://calendly.com/krzysztof-warda-egodziny/30min",
                      "_blank",
                    )
                  }
                >
                  Umów demo
                </Button>
                <Button
                  variant="outline-dark"
                  className="btn-lg"
                  href="/kontakt"
                >
                  Skontaktuj się z nami
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
}

export default CaseStudyStaldachBud;
